import {FC, useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import uuid from 'react-uuid'
import Swal from 'sweetalert2'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Button} from '../../../components/Button/Button'
import {Input} from '../../../components/Input/Input'
import {Loading} from '../../../components/Loading/Loading'
import {GET, POST} from '../../../services/api'
import {i18n} from '../../../translate/i18n'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import SVG from 'react-inlinesvg'
import useAuth from '../../../hooks/useAuth'
import {ModalWrapper} from '../../../components/Modals/General/ModalWrapper/ModalWrapper'
import useModals from '../../../hooks/useModals'
import usePluginsSpace from '../../../hooks/usePluginSpace'

type segmentoAgregador = {
  name: string
  order: number
  image: string
  type: string
  active: boolean
  id: number
}

type newSegmento = {
  pluginspaceId: number
  segment: number
  id: number
}

type mostraSetor = {
  value: string
  select: string
}

type Icon = {
  id: number
  svg: string
  description: string
  category: string
}

const Content: FC = () => {
  const navigate = useNavigate()
  const {loginInfo} = useAuth()
  const [loading, setLoading] = useState(false)
  const {pluginSpace} = usePluginsSpace()

  const [setorCreate, setSetorCreate] = useState<string>('')
  const [categoriaCreate, setCategoriaCreate] = useState<string>('')
  const [ordemCreate, setOrdemCreate] = useState<number>(0)
  const [descricaoCreate, setDescricaoCreate] = useState<string>('')

  const [mostraSetor, setMostraSetor] = useState<mostraSetor[]>([])
  const [, setSetor] = useState<segmentoAgregador[]>([])
  const [, setSegmentos] = useState<any[]>([])

  const [, setCategoryIcons] = useState<any[]>([
    {
      select: 'Todos',
      value: -1,
    },
  ])
  const [icones, setIcones] = useState<Icon[]>([])
  const [iconesFiltered, setIconesFiltered] = useState<Icon[]>([])
  const [iconeSelected, setIconeSelected] = useState<any>()
  const [searchIcon, setSearchIcon] = useState<string>('')

  const {showWrapperModal} = useModals()

  const editText = async (value: string) => {
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = value

    const reetiraTexto = tempDiv.innerText

    setDescricaoCreate(reetiraTexto)
  }

  const filterIcons = (searchTerm: string) => {
    if (!searchTerm.trim()) {
      setIconesFiltered(icones)
    } else {
      const filtered = icones.filter(
        (icon) =>
          icon.description && icon.description.toLowerCase().includes(searchTerm.toLowerCase())
      )
      setIconesFiltered(filtered)
    }
  }

  const handleSearchIcon = (value: string) => {
    setSearchIcon(value)
    filterIcons(value)
  }

  const getSetores = async () => {
    try {
      const setoresRes = await GET(`segment`)

      const newSetores = setoresRes.data.map((setor: segmentoAgregador) => {
        return {
          name: setor.name,
          order: setor.order,
          image: setor.image,
          type: setor.type,
          active: setor.active,
          id: setor.id,
        }
      })

      setSetor(newSetores)

      return newSetores
    } catch (e) {
      console.log(e)
    }
  }

  const getSegmentosPluginSpace = async () => {
    try {
      const segmentosPluginSpace = await GET('pluginspacesegment')
      // eslint-disable-next-line array-callback-return
      let newSegmento = segmentosPluginSpace.data.filter((segment: newSegmento) => {
        if (segment.pluginspaceId === loginInfo.pluginspaceId) {
          return segment
        }
      })

      newSegmento = newSegmento.map((segment: newSegmento) => {
        return {segment: Number(segment.segment), id: Number(segment.id)}
      })

      setSegmentos(newSegmento)

      return newSegmento
    } catch (error) {
      console.log(error)
    }
  }

  const setSetorAtivo = async (allSetor: segmentoAgregador[], setorAtivo: newSegmento[]) => {
    const ativados = allSetor.filter((setor) => {
      return setorAtivo.some((setorAtivo) => setor.id === setorAtivo.segment)
    })

    const idAtivados = setorAtivo.map((setor) => {
      return setor.id
    })

    const mostraSetor = ativados.map((ativados, i) => {
      return {
        select: ativados.name,
        value: idAtivados[i].toString(),
      }
    })

    setMostraSetor(mostraSetor)
  }

  const create = async () => {
    try {
      if (!setorCreate || !categoriaCreate || !iconeSelected) {
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos!',
        })
      } else {
        setLoading(true)
        const setorCode = Object.values(setorCreate)
        let imageRes = {
          success: false,
          image: '',
        }

        imageRes = await sendSvgAWS()

        let res

        if (imageRes.success) {
          res = await POST('/classification', {
            type: 'aggregator',
            order: ordemCreate,
            name: setorCode[1],
            shortname: categoriaCreate,
            code: uuid().slice(0, 40) + '/' + setorCode[0],
            status: true,
            img: imageRes.image,
            description: descricaoCreate,
          })
        }

        setLoading(false)
        if (res.success === true) {
          Swal.fire({
            icon: 'success',
            title: 'Categoria cadastrada',
            text: 'Cadastro realizado com sucesso!',
          }).then(() => navigate('/agregador/category'))
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao cadastrar a categoria!',
          })
        }
      }
    } catch (e: any) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e ?? 'Erro ao cadastrar categoria!',
      })
    }
  }

  async function getIcones() {
    try {
      setLoading(true)

      const svgCategory = await POST('svgcategory/filter', {
        status: true,
      })

      const auxCategory = [
        {
          select: 'Todos',
          value: -1,
        },
      ]

      svgCategory.data.forEach((el: any) => {
        auxCategory.push({
          select: el.name,
          value: el.id,
        })
      })

      setCategoryIcons(auxCategory)

      const res = await GET('svgwebapp')

      if (!res || !res.success) {
        Swal.fire({
          icon: 'error',
          titleText: 'Erro',
          text: 'Erro ao encontrar os tipos',
        })
        setLoading(false)
        return
      }

      setIcones(res.data)
      setIconesFiltered(res.data)

      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)

      Swal.fire({
        icon: 'error',
        titleText: 'Erro',
        text: 'Erro ao encontrar os tipos',
      })
    }
  }

  async function sendSvgAWS() {
    try {
      let bucket = `img.ninegrid.com`
      const response = await POST('/upload-images/upload-svg', {
        file: iconeSelected.svg,
        path: bucket,
        name: `${pluginSpace!.subdomain}/category/${categoriaCreate}-${uuid()}.svg`,
      })
      return response
    } catch (error) {
      return {
        error: error,
        success: false,
        data: {},
      }
    }
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchData = async () => {
    setLoading(true)
    const allSetor = await getSetores()
    const setorAtivo = await getSegmentosPluginSpace()
    await setSetorAtivo(allSetor, setorAtivo)
    await getIcones()
    setLoading(false)
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{`${i18n.t(
                  `buttons.create`
                )} ${i18n.t(`smart_order.category`)}`}</span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  Preencha as informações abaixo e clique no botão salvar para criar uma nova
                  categoria.
                </span>
              </h3>
            </div>
            <div className='card-body'>
              <div className='row pb-6'>
                <div className='col d-flex justify-content-between'>
                  <div className='row'>
                    <div className='col-12 col-md-8 pb-6' style={{zIndex: 500}}>
                      <div className='d-flex gap-2'>
                        <span>Setor</span>
                        <div className='d-flex gap-2'>
                          <span className='text-muted'>·</span>
                          <span className='text-muted'>
                            Escolha o setor relacionado a nova categoria
                          </span>
                        </div>
                      </div>
                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        options={mostraSetor}
                        placeholder={'Setores'}
                        search={true}
                        value={setorCreate}
                        change={(value: string) => {
                          setSetorCreate(value)
                        }}
                      />
                    </div>
                    <div className='col-12'>
                      <div className='d-flex gap-2'>
                        <span>Categoria</span>
                        <div className='d-flex gap-2'>
                          <span className='text-muted'>·</span>
                          <span className='text-muted'>Máximo de 15 caracteres</span>
                        </div>
                      </div>
                      <Input
                        inputAttr={{
                          type: 'text',
                        }}
                        placeholder={'Categoria'}
                        value={categoriaCreate}
                        change={(value: string) => setCategoriaCreate(value.substring(0, 15))}
                      />
                    </div>
                  </div>
                  <div>
                    <Input
                      inputAttr={{
                        type: 'icon',
                      }}
                      onAction={() => showWrapperModal('Ícones')}
                      label='Ícone'
                      value={iconeSelected}
                      change={(value: any) => {
                        setIconeSelected(value)
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='row pb-6'>
                <div className='col-12 col-md-2'>
                  <div>
                    <span>Ordem</span>
                    <Input
                      inputAttr={{
                        type: 'number',
                      }}
                      placeholder={'0'}
                      value={ordemCreate}
                      change={(value: number) => setOrdemCreate(value)}
                    />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col'>
                  <div>
                    <span>Descrição</span>
                    <Input
                      rows={4}
                      inputAttr={{
                        type: 'textarea',
                      }}
                      placeholder={'Descrição'}
                      value={descricaoCreate}
                      change={(value: any) => {
                        editText(value)
                      }}
                    />
                    {/* <EditorQuill
                        value={descricaoCreate}
                        change={(value: string) => editText(value)}
                      /> */}
                  </div>
                </div>
              </div>
              <div className='d-flex justify-content-between mt-5'>
                <Button
                  text='Voltar'
                  color='info'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => {
                    Swal.fire({
                      title: 'Você tem certeza?',
                      text: 'Os dados que foram digitados serão perdidos.',
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#d33',
                      confirmButtonText: 'Sim, voltar!',
                      cancelButtonText: 'Não, cancelar!',
                    }).then((result) => {
                      if (result.isConfirmed) {
                        navigate(-1)
                      }
                    })
                  }}
                  btnClass='fw-bolder'
                />
                <Button
                  text='Salvar'
                  color='primary'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => create()}
                  btnClass='fw-bolder'
                />
              </div>
            </div>
          </div>
          {/* <div style={{ width: 'auto', position: 'fixed', bottom: 40, right: 60 }}>
                <Button
                    text='Voltar'
                    color='info'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                        type: 'button',
                    }}
                    click={() => {
                        Swal.fire({
                            title: 'Você tem certeza?',
                            text: 'Os dados que foram digitados serão perdidos.',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Sim, voltar!',
                            cancelButtonText: 'Não, cancelar!',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate(-1)
                            }
                        })
                    }}
                    btnClass='fw-bolder me-3'
                />
                <Button
                    text='Salvar'
                    color='primary'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                        type: 'button',
                    }}
                    click={() => create()}
                    btnClass='fw-bolder'
                />
              </div> */}
        </div>
      )}
      <ModalWrapper confirmAction={() => {}} maxWidth={true} width={40}>
        <div
          className='d-flex flex-column gap-5 card'
          style={{
            height: '30rem', // Reduzir de 25rem para 23rem
          }}
        >
          <div
            className='d-flex justify-content-between align-items-start pt-4 px-4'
            style={{paddingBottom: '15px'}}
          >
            <div className='d-flex flex-column' style={{width: '300px', gap: '4px'}}>
              <span className='fw-bold'>Buscar ícone</span>
              <div className='position-relative'>
                <Input
                  inputAttr={{
                    type: 'text',
                    style: {
                      paddingRight: '40px',
                      height: '38px',
                      width: '100%',
                    },
                  }}
                  placeholder='Digite para buscar...'
                  value={searchIcon}
                  change={(value: string) => handleSearchIcon(value)}
                />
                <i
                  className='fas fa-search position-absolute text-muted'
                  style={{
                    right: '14px',
                    top: '62%',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none',
                    fontSize: '14px',
                    zIndex: 10,
                  }}
                />
              </div>
            </div>
            <div className='d-flex flex-column align-items-center gap-2'>
              <span className='fw-bold text-center'>Ícone selecionado</span>
              <div
                className='p-4 border border-primary rounded'
                style={{
                  minHeight: '77px',
                  minWidth: '77px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {iconeSelected?.svg ? (
                  <SVG
                    src={iconeSelected.svg}
                    style={{
                      width: '45px',
                      height: '45px',
                    }}
                  />
                ) : (
                  <span className='text-muted fs-7'>Selecione um ícone</span>
                )}
              </div>
            </div>
          </div>
          <div
            className='card-body d-flex gap-3 flex-row flex-wrap overflow-auto'
            style={{padding: '20px'}}
          >
            {iconesFiltered.map((icon) => (
              <div
                key={icon.id}
                className={`d-flex flex-column align-items-center p-3 cursor-pointer rounded ${
                  iconeSelected?.id === icon.id
                    ? 'border border-primary bg-light-primary'
                    : 'border border-light hover-shadow'
                }`}
                onClick={() => setIconeSelected(icon)}
                style={{
                  width: '120px',
                  height: '100px',
                  transition: 'all 0.2s ease',
                }}
              >
                <SVG
                  src={icon.svg}
                  style={{
                    width: '40px',
                    height: '40px',
                    marginBottom: '8px',
                  }}
                />
                <span
                  className='text-center text-truncate fw-bold'
                  style={{
                    fontSize: '11px',
                    width: '100%',
                    lineHeight: '1.2',
                  }}
                  title={icon.description || 'Sem descrição'}
                >
                  {icon.description || 'Sem descrição'}
                </span>
              </div>
            ))}
            {iconesFiltered.length === 0 && searchIcon && (
              <div className='d-flex justify-content-center align-items-center w-100'>
                <div className='text-center'>
                  <i className='fas fa-search fs-2 text-muted mb-3'></i>
                  <p className='text-muted mb-0'>Nenhum ícone encontrado</p>
                  <small className='text-muted'>Tente uma palavra-chave diferente</small>
                </div>
              </div>
            )}
          </div>
        </div>
      </ModalWrapper>
    </>
  )
}

const FeedCriarCategoriasAgregador: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`Criar Categoria`), path: '/agregador/category/create', isActive: true},
        ]}
      ></PageTitle>
      <Content />
    </>
  )
}

export {FeedCriarCategoriasAgregador}
